import React, { Component } from 'react';
import Autosuggest from 'react-autosuggest';
import { toast } from 'react-toastify';
import {
  getKeySuggestions,
  getSuggestion,
  getValueSuggestions,
} from '../../../common/utils/api_utils';
import RestAPICollectionFieldsModal from '../../external-api/rest-api/RestAPICollectionFieldsModal';

export default class RestClientHeaderRow extends Component {
  static propTypes = {};

  state = {
    paramKey: this.props.headerRow.key,
    paramValue: this.props.headerRow.value,
    key: '',
    value: '',
    headers: [],
    values: [],
    showModalForCollectionFields: false,
  };

  toggleFieldsModal = () => {
    this.setState({ showModalForCollectionFields: !this.state.showModalForCollectionFields });
  };
  deleteRow = () => {
    this.setState({
      paramKey: '',
      key: '',
      paramValue: '',
      value: '',
    });
    this.props.headerRow.key = '';
    this.props.headerRow.value = '';
  };
  copyToClipboard = () => {
    this.setState({
      copied: true,
      showModalForCollectionFields: !this.state.showModalForCollectionFields,
    });
    toast.success('Copied to clipboard');
    setTimeout(() => {
      this.setState({ copied: false });
    }, 2000);
  };

  insertTextToParamInput = (textToInsert) => {
    if (textToInsert) {
      const reqHeaderInputElem = document.getElementById(`requestHeader${this.props.headerRow.id}`);
      let start = reqHeaderInputElem.selectionStart;
      // obtain the index of the last selected character
      let finish = reqHeaderInputElem.selectionEnd;
      //obtain all Text
      let allText = reqHeaderInputElem.value;
      // obtain the selected text
      let sel = allText.substring(start, finish);
      let newText = '';
      if (sel) {
        newText = allText.replace(sel, textToInsert);
      } else {
        newText = allText + textToInsert;
      }

      this.setState({
        showModalForCollectionFields: !this.state.showModalForCollectionFields,
        value: newText,
        paramValue: newText,
      });
      this.props.headerRow.value = newText;
      toast.success('Inserted into Request Headers Value');
    }
  };

  showCollectionFieldModal = () => {
    const {
      collectionName,
      bodyDataFrom,
      externalapi,
      projectDetail,
      home: { iPlugins },
    } = this.props;
    const { collections } = externalapi ? externalapi : '';
    const selectedCollection =
      collectionName &&
      collections &&
      collections.find((collection) => {
        return collection.collectionName === collectionName;
      });
    let tenantCollectionId = '';
    let userSettingCollectionId = '';
    let subTenantCollectionId = '';
    const multiTenantPlugin = iPlugins.find((e) => e.code === 'MULTI_TENANT_SAAS');
    if (multiTenantPlugin) {
      tenantCollectionId = multiTenantPlugin.setting.multiTenantCollection;
      userSettingCollectionId = multiTenantPlugin.setting.userSettingsCollection || '';
      subTenantCollectionId = multiTenantPlugin.setting.subTenantCollection || '';
    }

    return (
      <RestAPICollectionFieldsModal
        selectedCollection={selectedCollection}
        collections={collections}
        projectDetail={projectDetail}
        copyToClipboard={this.copyToClipboard}
        insertTextToEditor={this.insertTextToParamInput}
        toggleFields={this.state.showModalForCollectionFields}
        toggleFieldsModal={this.toggleFieldsModal}
        bodyDataFrom={bodyDataFrom}
        tenantCollectionId={tenantCollectionId}
        userSettingCollectionId={userSettingCollectionId}
        subTenantCollectionId={subTenantCollectionId}
        hide={['tenantDerivedFields', 'userSettingDerivedFields', 'subTenantDerivedFields']}
      />
    );
  };

  onChange = (event, { newValue }) => {
    this.setState({
      key: newValue,
      paramKey: newValue,
    });
    this.props.headerRow.key = newValue;
    this.props.createNewRow(this.props.headerRow);
  };

  onValueChange = (event, { newValue }) => {
    this.setState({
      value: newValue,
      paramValue: newValue,
    });
    this.props.headerRow.value = newValue;
    this.props.createNewRow(this.props.headerRow);
  };

  onHeaderSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      headers: getKeySuggestions(value),
    });
  };

  onValueSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      values: getValueSuggestions(value),
    });
  };

  onHeaderSuggestionsClearRequested = () => {
    this.setState({
      headers: [],
    });
  };

  onValueSuggestionsClearRequested = () => {
    this.setState({
      values: [],
    });
  };

  renderSuggestion = (suggestion) => <div>{suggestion.text}</div>;

  render() {
    const { paramKey, paramValue, headers, values } = this.state;
    const inputKeyProps = {
      placeholder: 'Key',
      value: paramKey,
      onChange: this.onChange,
      className: 'form-control form-control-sm',
    };
    const inputValueProps = {
      placeholder: 'Value',
      value: paramValue,
      onChange: this.onValueChange,
      className: 'form-control form-control-sm',
      id: `requestHeader${this.props.headerRow.id}`,
    };

    return (
      <>
        {this.state.showModalForCollectionFields && this.showCollectionFieldModal()}
        <div className="col-md-4 col-lg-4">
          <Autosuggest
            suggestions={headers}
            onSuggestionsFetchRequested={this.onHeaderSuggestionsFetchRequested}
            onSuggestionsClearRequested={this.onHeaderSuggestionsClearRequested}
            getSuggestionValue={getSuggestion}
            renderSuggestion={this.renderSuggestion}
            inputProps={inputKeyProps}
          />
        </div>
        <div className="col-md-8 col-lg-8">
          <div className="input-group">
            <Autosuggest
              suggestions={values}
              onSuggestionsFetchRequested={this.onValueSuggestionsFetchRequested}
              onSuggestionsClearRequested={this.onValueSuggestionsClearRequested}
              getSuggestionValue={getSuggestion}
              renderSuggestion={this.renderSuggestion}
              inputProps={inputValueProps}
              theme={{
                container: { flex: '1 1 auto', width: '1%' },
              }}
            />
            <div className="input-group-append">
              <span className="input-group-text">
                <button
                  type="button"
                  className="btn btn-theme-submit btn-xs btn-icon-only"
                  title="Add Fields"
                  onClick={() => {
                    this.toggleFieldsModal();
                  }}
                >
                  <i className="wb webconnect-plus" />
                </button>
                <button
                  type="button"
                  className="btn  btn-xs btn-theme-delete btn-icon-only ml-1"
                  title="Delete Fields"
                  onClick={() => {
                    this.deleteRow();
                  }}
                >
                  <i className="wb webconnect-times" />
                </button>
              </span>
            </div>
          </div>
        </div>
      </>
    );
  }
}
